export default "__VITE_ASSET__MP5ltaboyZrB9QLiM$uBig__"